import React, { useState } from "react";
import { IoClose, IoCopyOutline } from "react-icons/io5";
import friendImg from "../../assets/images/friends-img.svg";
import badge1 from "../../assets/images/invite-badge-1.svg";
import badge2 from "../../assets/images/invite-badge-2.svg";
import badge3 from "../../assets/images/invite-badge-3.svg";
import badge4 from "../../assets/images/invite-badge-4.svg";
import badge5 from "../../assets/images/invite-badge-5.svg";
import badge6 from "../../assets/images/invite-badge-6.svg";
import badge7 from "../../assets/images/invite-badge-7.svg";
import badge8 from "../../assets/images/invite-badge-8.svg";
import badge9 from "../../assets/images/invite-badge-9.svg";
import badge10 from "../../assets/images/invite-badge-10.svg";
import Modal from "../../components/Modal/Modal";
import inviteModalImg from "../../assets/images/invite-modal-img.svg";
import referralModalImg from "../../assets/images/referral-modal-img.svg";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper";
import { useDispatch, useSelector } from "react-redux";
import { getUserProfile } from "../../store/user/user.selector";
import { copyToClipboard } from "../../helpers/utility";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { addReferralCodeRequest } from "../../store/user/user.actions";

const cardBadges = [
    {
        id: 0,
        badgeImg: badge1,
        title: "Official Pro Badge",
        discription:
            "Just like a verified badges so that a customer has  full ,trust in you",
        color: "#EEFFF3",
        borderColor: "#CAFFE6",
    },
    {
        id: 1,
        badgeImg: badge2,
        title: "Unlimited, 4 hours time limit per live",
        discription: "Extension of your video streaming",
        color: "#FFECE4",
        borderColor: "#FFD8C8",
    },
    {
        id: 2,
        badgeImg: badge3,
        title: "Up to 20 products live showcase",
        discription: "Extra slots to showcase and sell products",
        color: "#E3F0FF",
        borderColor: "#D0EAFF",
    },
    {
        id: 3,
        badgeImg: badge4,
        title: "Intuitive Dashboard",
        discription:
            "Views subscription, earnings, engagement and sales report",
        color: "#E3FFFF",
        borderColor: "#D0EAFF",
    },
    {
        id: 4,
        badgeImg: badge5,
        title: "Unlimited product listing",
        discription: "Upload and sell as many products as you want",
        color: "#EEFFF3",
        borderColor: "#CAFFE6",
    },
    {
        id: 5,
        badgeImg: badge6,
        title: "VIP circle",
        discription: "Unlimited circles with multiple subscription fees ",
        color: "#FFF8E0",
        borderColor: "#FFEEB4",
    },
    {
        id: 6,
        badgeImg: badge7,
        title: "Private direct message",
        discription: "Control who can send you private messages",
        color: "#E3F0FF",
        borderColor: "#D0EAFF",
    },
    {
        id: 7,
        badgeImg: badge8,
        title: "Full HD 1080p live video",
        discription: "Hi-res vide, adaptive bitrate, screen grab disable",
        color: "#FFF5E5",
        borderColor: "#F4E0BE",
    },
    {
        id: 8,
        badgeImg: badge9,
        title: "Up to 6 co-hosts invite",
        discription: "Invite upto 6 co-hosts into the live.",
        color: "#FFF8E0",
        borderColor: "#FFEEB4",
    },
    {
        id: 9,
        badgeImg: badge10,
        title: "Unlimited recorded instant video",
        discription: "Record and share unlimited instant videos.",
        color: "#EAF1FF",
        borderColor: "#EAF1FF",
    },
];

const InviteFriends = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const [inviteModal, setInviteModal] = useState(false);
    const [referralModal, setReferralModal] = useState(false);
    const [referCode, setReferCode] = useState("");

    const { userProfile } = useSelector((state) => {
        return {
            userProfile: getUserProfile(state),
        };
    });

    useEffect(() => {
        let qs = new URLSearchParams(location.search);
        if (qs.get("ref")) {
            setReferCode(qs.get("ref"));
            setReferralModal(true);
        }
    }, []);

    return (
        <div className="px-2 sm:px-4 lg:px-8 py-7">
            <div className="mb-5">
                <div className=" mb-3.5">
                    <h1 className="text-2xl font-bold text-ebony-color capitalize">
                        Invite Friends
                    </h1>
                </div>
                <div className=" bg-white w-full rounded-[10px] flex flex-col md:flex-row justify-between ">
                    <div className="px-5 py-[30px] max-w-[560px]">
                        <div className="">
                            <h2 className="font-bold text-lg sm:text-xl text-ebony-color mb-1">
                                Invite your friends to Ulalive.
                            </h2>
                            <p className="text-sm text-black-60 mb-1">
                                Get a{" "}
                                <span className="uppercase text-purple-color">
                                    FREE PRO
                                </span>{" "}
                                account for 14 days when you invite a friend to
                                sign up for a Ulalive. Your referred friend will
                                enjoy it too!
                            </p>
                            <p className="text-sm font-medium text-orange-color mb-3">
                                *No referral limit
                            </p>
                        </div>

                        <div className="flex flex-col sm:flex-row items-center gap-2.5">
                            <button
                                onClick={() => setInviteModal(true)}
                                className="py-2.5 w-[164px] bg-orange-color text-white capitalize font-bold text-sm rounded-lg"
                            >
                                Invite
                            </button>
                            <button
                                onClick={() => setReferralModal(true)}
                                className="py-2.5 w-[164px] bg-white border border-black-10 text-black-50 capitalize font-bold text-sm rounded-lg"
                            >
                                redeem
                            </button>
                        </div>
                    </div>
                    <div className="flex items-end lg:shrink-0">
                        <img src={friendImg} classNamew="w-full" alt="" />
                    </div>
                </div>
            </div>

            <div className="">
                <div className="sm:hidden">
                    <Swiper
                        autoplay={{
                            delay: 2500,
                            disableOnInteraction: false,
                        }}
                        loop={true}
                        slidesPerView={1}
                        navigation={true}
                        spaceBetween={10}
                        pagination={{
                            clickable: true,
                        }}
                        modules={[Navigation, Autoplay]}
                        className="mySwiper"
                    >
                        {cardBadges.map((card) => {
                            return (
                                <SwiperSlide key={card.id}>
                                    <InviteCard card={card} key={card.id} />
                                </SwiperSlide>
                            );
                        })}
                    </Swiper>
                </div>
                <div className="hidden sm:block">
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3 ">
                        {cardBadges.map((card) => {
                            return <InviteCard card={card} key={card.id} />;
                        })}
                    </div>
                </div>
            </div>

            {/* Invite Modal  */}
            <Modal show={inviteModal} onClose={() => setInviteModal(false)}>
                <div className="max-w-[437px]">
                    <img
                        src={inviteModalImg}
                        className="max-w-[380px] w-full sm:px-3"
                        alt=""
                    />
                    <div className="mt-6">
                        <h3 className="text-lg font-bold text-ebony-color text-center mb-8">
                            Invite friends
                        </h3>
                        <form onSubmit={(e) => e.preventDefault()}>
                            <div className="">
                                <div className="mb-[13px]">
                                    <label
                                        className="text-sm font-medium text-black-60 mb-1"
                                        htmlFor="referral-code"
                                    >
                                        Your referral code
                                    </label>
                                    <div className="relative">
                                        <input
                                            type="text"
                                            className="py-[9px] px-[13px] w-full text-sm text-black-60 hover:text-purple-color rounded-md border border-[#D1D5DB] modal-input-shadow outline-none cursor-default caret-transparent"
                                            value={userProfile.refCode}
                                            id="referral-code"
                                        />
                                        <IoCopyOutline
                                            onClick={() =>
                                                copyToClipboard("referral-code")
                                            }
                                            className="text-black-50 hover:text-purple-color text-lg cursor-pointer absolute top-2/4 right-1.5 -translate-y-2/4"
                                        />
                                    </div>
                                </div>
                                <div className="mb-7">
                                    <label
                                        className="text-sm font-medium text-black-60 mb-1"
                                        htmlFor="referral-code"
                                    >
                                        Share profile Invitation link
                                    </label>
                                    <div className="relative">
                                        <input
                                            type="text"
                                            className="py-[9px] px-[13px] w-full text-sm text-black-60 hover:text-purple-color rounded-md border border-[#D1D5DB] modal-input-shadow outline-none cursor-default caret-transparent"
                                            value={
                                                process.env.REACT_APP_URL +
                                                "/page/refer?ref=" +
                                                userProfile.refCode
                                            }
                                            id="referral-code1"
                                        />
                                        <IoCopyOutline
                                            onClick={() =>
                                                copyToClipboard(
                                                    "referral-code1"
                                                )
                                            }
                                            className="text-black-50 hover:text-purple-color text-lg cursor-pointer absolute top-2/4 right-1.5 -translate-y-2/4"
                                        />
                                    </div>
                                </div>
                                <button
                                    onClick={() => setInviteModal(false)}
                                    type="submit"
                                    className="text-sm font-bold text-white py-2.5 w-full capitalize bg-orange-color rounded-lg"
                                >
                                    done
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </Modal>

            {/* Referral Modal  */}
            <Modal show={referralModal} onClose={() => setReferralModal(false)}>
                <div className="max-w-[437px]">
                    <img
                        src={referralModalImg}
                        className="max-w-[380px] w-full sm:px-3"
                        alt=""
                    />
                    <div className="mt-6">
                        <h3 className="text-lg font-bold text-ebony-color text-center mb-8">
                            Invite friends
                        </h3>
                        <form onSubmit={(e) => e.preventDefault()}>
                            <div className="">
                                <div className="mb-7">
                                    <label
                                        className="text-sm font-medium text-black-60 mb-1 capitalize"
                                        htmlFor="referral-code"
                                    >
                                        enter code
                                    </label>
                                    <div className="relative">
                                        <input
                                            type="text"
                                            className="py-[9px] px-[13px] w-full text-sm text-black-60 hover:text-purple-color rounded-md border border-[#D1D5DB] modal-input-shadow outline-none"
                                            id="referral-code"
                                            value={referCode}
                                            onChange={(e) =>
                                                setReferCode(e.target.value)
                                            }
                                        />
                                        <IoCopyOutline className="text-black-50 text-lg cursor-pointer absolute top-2/4 right-1.5 -translate-y-2/4" />
                                    </div>
                                </div>
                                <button
                                    onClick={() => {
                                        dispatch(
                                            addReferralCodeRequest(referCode)
                                        );
                                        setReferralModal(false);
                                    }}
                                    type="submit"
                                    className="text-sm font-bold text-white py-2.5 w-full capitalize bg-orange-color rounded-lg"
                                >
                                    done
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export const InviteCard = ({ card }) => {
    return (
        <div
            key={card.id}
            className="p-5 rounded-lg border min-h-[151px]"
            style={{
                backgroundColor: `${card.color}`,
                borderColor: `${card.borderColor}`,
            }}
        >
            <img
                src={card.badgeImg}
                className="w-10 aspect-square mx-auto"
                alt=""
            />
            <div className="mt-3 text-center">
                <h4 className="text-sm font-medium text-ebony-color mb-1.5">
                    {card.title}
                </h4>
                <p className="text-sm text-black-60 font-medium">
                    {card.discription}
                </p>
            </div>
        </div>
    );
};

export default InviteFriends;
